import { render } from "./ProjectsViewFullKit.vue?vue&type=template&id=e312ae8c"
import script from "./ProjectsViewFullKit.vue?vue&type=script&lang=js"
export * from "./ProjectsViewFullKit.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__